import axios from 'axios'
import _ from 'lodash'
import parser from 'ua-parser-js'
import AppState from '@/plugins/appstate'
import Logger from '@/plugins/logger'

const paymentStatus = process.env.VUE_APP_PAYMENT_STATUS
const base = `${process.env.VUE_APP_API_ADDRESS}/lmm/api/${process.env.VUE_APP_API_VERSION}/`
const serv = {
  launcher: `${process.env.VUE_APP_API_ADDRESS}/launcher/api/${process.env.VUE_APP_API_VERSION}/`,
  upload: `${process.env.VUE_APP_API_ADDRESS}/upload`,
  image: `${process.env.VUE_APP_API_ADDRESS}/images`,
  download: `${process.env.VUE_APP_API_ADDRESS}/download`,
  live: `${process.env.VUE_APP_API_ADDRESS}/live_view`,
  qrcode: `${process.env.VUE_APP_API_ADDRESS}/qr_code`,
  pay: `${process.env.VUE_APP_PAYMENT_ADDRESS}`,
  domain: location.hostname,
  origin: location.origin
}

var _token = null

// Fallback Settings
const timeout = 30000

// Headers
var headers = {
  'Content-Type': 'application/json',
  'Accept': 'application/json'
}

// Methods
const SetHeader = function (key, value) {
  if (key === 'token') _token = value
  axios.defaults.headers.common[key] = value
  return axios.defaults.headers.common
}

const SetHeaders = function (keyValueObj) {
  headers = Object.assign({}, headers, keyValueObj)
}

const GetHeader = function (key) {
  return axios.defaults.headers.common[key]
}

const GetHeaders = function () {
  return headers
}

const removeHeader = function (key) {
  delete axios.defaults.headers.common[key]
  return axios.defaults.headers.common
}

const CreateInstance = function (endpoint, rebase) {
  let apiBase = rebase ? serv[rebase] : base
  var instance = axios.create({
    baseURL: apiBase + endpoint,
    timeout: timeout,
    headers: headers,
    withCredentials: false
  })

  const ua = parser()

  instance.interceptors.request.use(
    config => {
      if (/IE/i.test(ua.browser.name)) {
        if (!config.params) config.params = {}
        config.params.cache = new Date().getTime()
      }
      if (_token && !config.headers.token) {
        config.headers.token = _token
      }
      return config
    }
  )

  instance.interceptors.response.use(
    resp => {
      // if (resp.data.status !== 200) {
      //   Router.push({ path: `/error/${resp.data.status}` })
      // }
      if (resp.data && resp.data.objects && _.isArray(resp.data.objects) && resp.data.objects.length === 1) {
        _.remove(resp.data.objects, v => /empty/i.test(v.pk))
      }
      return resp
    },
    err => {
      if (err.response) {
        // 서버에러
        Logger.error(err.response)
        // const code = err.response.status || 500
        // Router.push({ path: `/error/${code}` })
        AppState.App.$awn.alert(AppState.App.$t('response_error_server_error'))
        return Promise.reject(err)
      }
      else {
        // 타임아웃 혹은 커넥션 실패
        Logger.error(err.code)
        AppState.App.$awn.alert(AppState.App.$t('response_error_connect_failed'))
        return Promise.reject(err)
      }
    }
  )
  return instance
}

export { SetHeader, SetHeaders, GetHeader, GetHeaders, removeHeader, CreateInstance, base, serv, paymentStatus }
